<script lang="ts">
    import { sanitizeHtml } from '../../utils/sanitize-html'

    export let label: string
    export let data: Record<string, any>
    export let value: any = undefined
    export let required = false
    export let readOnly = false
</script>

<div class="view-label-block">
    <div class="view-html">{@html sanitizeHtml(data?.text)}</div>
</div>

<style>
    .view-html {
        font-size: 0.92rem;
        color: #495057;
        line-height: 1.5;
    }
    .view-html :global(p) {
        margin: 0 0 8px;
    }
    .view-html :global(p:last-child) {
        margin-bottom: 0;
    }
    .view-html :global(ul),
    .view-html :global(ol) {
        margin: 0 0 8px;
        padding-left: 22px;
    }
    /* Imagem colada pelo editor entra sem width/height e ia para o layout no tamanho natural —
       um arquivo de 15000px de largura quebrava a página e obrigava o navegador a rasterizar tudo
       isso. Não reduz a memória de decodificação (essa depende do tamanho do arquivo enviado), mas
       corta o custo de layout e pintura. `:global` porque conteúdo de {@html} não recebe a classe
       de escopo do Svelte. */
    .view-html :global(img) {
        max-width: 100%;
        height: auto;
    }
    .view-html :global(a) {
        color: var(--cs2-accent, #4263eb);
        text-decoration: underline;
    }
    .view-html :global(table) {
        border-collapse: collapse;
        margin: 8px 0;
    }
    .view-html :global(table td),
    .view-html :global(table th) {
        border: 1px solid #dee2e6;
        padding: 6px 10px;
    }
</style>
